// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.45);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.profile-popup {
    background: white;
    border-radius: 8px;
    padding: 20px 24px;
    min-width: 280px;
    box-shadow: 0 10px 30px rgba(0,0,0,.25);
}

.profile-row {
    margin: 8px 0;
}

.profile-close {
    margin-top: 16px;
}`, "",{"version":3,"sources":["webpack://./src/web/component/ProfilePopup/styles.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,4BAA4B;IAC5B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".profile-backdrop {\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(0,0,0,0.45);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n}\r\n\r\n.profile-popup {\r\n    background: white;\r\n    border-radius: 8px;\r\n    padding: 20px 24px;\r\n    min-width: 280px;\r\n    box-shadow: 0 10px 30px rgba(0,0,0,.25);\r\n}\r\n\r\n.profile-row {\r\n    margin: 8px 0;\r\n}\r\n\r\n.profile-close {\r\n    margin-top: 16px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
